import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { useSettingsStore } from '@/store/modules/settings';

import { storeToRefs } from 'pinia';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    collapse: {
      type: Boolean,
      default() {
        return false;
      }
    },
    fixedHeader: {
      type: Boolean,
      default() {
        return true;
      }
    },
    showTabs: {
      type: Boolean,
      default() {
        return true;
      }
    }
  },
  setup(__props) {
    const settingsStore = useSettingsStore();
    const {
      theme
    } = storeToRefs(settingsStore);
    return (_ctx, _cache) => {
      const _component_vab_column_bar = _resolveComponent("vab-column-bar");
      const _component_vab_nav = _resolveComponent("vab-nav");
      const _component_vab_tabs = _resolveComponent("vab-tabs");
      const _component_vab_app_main = _resolveComponent("vab-app-main");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["vab-layout-column", {
          fixed: __props.fixedHeader,
          'no-tabs-bar': !__props.showTabs
        }])
      }, [_createVNode(_component_vab_column_bar), _createElementVNode("div", {
        class: _normalizeClass(["vab-main", {
          ['vab-main-' + _unref(theme).columnStyle]: true,
          'is-collapse-main': __props.collapse
        }])
      }, [_createElementVNode("div", {
        class: _normalizeClass(["vab-layout-header", {
          'fixed-header': __props.fixedHeader
        }])
      }, [_createVNode(_component_vab_nav), _withDirectives(_createVNode(_component_vab_tabs, null, null, 512), [[_vShow, __props.showTabs]])], 2), _createVNode(_component_vab_app_main)], 2)], 2);
    };
  }
});